export default "__VITE_ASSET__CLKlo6Qx__"